<template>
  <div class="tipsBindPhone" v-if="needBind || needBindMobile">
    <div class="Bg"></div>
    <div class="center-form">
      <span class="close-icon" @click="closeFn"></span>
      <div class="tips-title">
        <span class="tips-logo"></span>
        <span class="title-big">安全提示</span>
        <span class="title-small">
          为保证您的账户安全
          建议您绑定手机号码
        </span>
      </div>
      <el-form
        ref="bindForm"
        :model="bindForm"
        :rules="bindFormRules"
        class="bindPhone-form"
        autocomplete="on"
        @submit.native.prevent
      >
        <el-form-item prop="bindPhone" class="bindPhone" :error="phoneErrorMsg">
          <el-input
            ref="bindPhone"
            v-model.number="bindForm.bindPhone"
            placeholder="请输入手机号"
            name="bindPhone"
            maxlength="11"
            type="tel"
            @focus="phoneErrorMsg=''"
            @keyup.enter.native="checkPhone()"
          />
        </el-form-item>
        <div class="check-phonecode-div">
          <el-form-item class="phone-code" prop="phoneCode" :error="codeErrorMsg">
            <el-input
              ref="phoneCode"
              v-model.trim="bindForm.phoneCode"
              placeholder="请输入验证码"
              name="phoneCode"
              type="tel"
              maxlength="6"
              @focus="codeErrorMsg=''"
              @keyup.enter.native="handleBind()"
            />
            <div class="codeError" v-show="error">{{errorInfo}}</div>
            <el-button :class="{'is-timing':able}" class="codeBtn" :disabled="able" type="primary">
              <span @click.stop="checkPhone" v-show="show">获取验证码</span>
              <span v-show="!show">{{count}} s</span>
            </el-button>
          </el-form-item>
          <el-button class="submitBtn" :loading="loading" type="primary" @click="handleBind()">确 定</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import user from "@/api/user";

export default {
  name: "tipsBindPhone",
  components: {},
  data() {
    const validatePhoneCode = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入短信验证码"));
      } else {
        callback();
      }
    };
    const validPhoneNumber = (rule, value, callback) => {
      if (("" + value).length !== 11) {
        callback(new Error("手机号格式不正确"));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };
    return {
      bindForm: {
        bindPhone: "",
        phoneCode: ""
      },
      phoneErrorMsg: "",
      codeErrorMsg: "",
      error:false,
      errorInfo: "",
      show: true,
      able: false,
      loading: false,
      timer: null,
      count: "",
      bindFormRules: {
        phoneCode: [
          { required: true, trigger: "blur", validator: validatePhoneCode }
        ],
        bindPhone: [
          { required: true, trigger: "blur", validator: validPhoneNumber },
          { type: "number", message: "手机号必须为数字值", trigger: "blur" }
        ]
      }
    };
  },
  computed: {},
  watch: {},
  props: {
    needBind: {
      type: Boolean,
      default: {}
    },
    needBindMobile: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    checkPhone() {
      this.$refs["bindForm"].validateField("bindPhone", error => {
        if (error) {
          return false;
        } else {
          this.getCode();
        }
      });
    },
    getCode() {
      this.show = false
      this.clockBtn();
      if (this.needBindMobile) {
        user
          .getMsgBindPhone(this.bindForm.bindPhone)
          .then(result => {
            this.phoneErrorMsg = "";
            this.codeErrorMsg = "";
            // this.$Message.success(result.data.message);
          })
          .catch(err => {
            console.log(err);
            this.$nextTick(function() {
              if (typeof err == "string") {
                err == "验证码错误"
                  ? (this.codeErrorMsg = err)
                  : (this.phoneErrorMsg = err);
              }
            });
          });
      } else {
        user
          .getMsgSocialBind(this.bindForm.bindPhone)
          .then(result => {
            // this.$Message.success(result.data.message);
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    closeFn() {
      this.$emit("emitFn", false);
    },
    clockBtn() {
      // 发送请求获取验证码
      this.able = true;
      // 倒计时
      const TIME_COUNT = 90;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            this.able = false;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    handleBind() {
      this.$refs.bindForm.validate(valid => {
        if (valid) {
          this.error = false
          this.errorInfo = ''
          this.loading = true;
          if (this.needBindMobile) {
            user
              .bindPhone({
                mobile: this.bindForm.bindPhone,
                mobile_verify_code: this.bindForm.phoneCode
              })
              .then(result => {
                this.$Message.success("绑定成功");
                this.phoneErrorMsg = "";
                this.codeErrorMsg = "";
                this.loading = false;
                this.closeFn();
                if (result.headers["x-intended"]) {
                  return (location.href = result.headers["x-intended"]);
                }
                this.$router.push({ name: "index" });
              })
              .catch(err => {
                console.log(err);
                typeof err == "string" ? (this.codeErrorMsg = err) : true;
                this.loading = false;
              });
          } else {
            user
              .socialPhoneBind({
                mobile: this.bindForm.bindPhone,
                mobile_verify_code: this.bindForm.phoneCode
              })
              .then(result => {
                this.$Message.success(result.data.message);
                this.loading = false;
                this.closeFn;
                if (result.headers["x-intended"]) {
                  return (location.href = result.headers["x-intended"]);
                } 
                if (this.isMobile) {
                  location.href = "https://m.huanqiu.com";
                } else {
                  this.$router.push({ name: "index" });
                }
              })
              .catch(err => {
                console.log(err);
                this.loading = false;
                if (err.status == 422) {
                  this.error = true
                  this.errorInfo = '验证码错误'
                  // this.codeErrorMsg = '验证码错误'
                }
                if (err.status == 409) {
                  //重置倒计时
                  this.show = true;
                  this.able = false;
                  clearInterval(this.timer);
                  this.timer = null;
                  //清空表单
                  this.bindForm.bindPhone = "";
                  this.bindForm.phoneCode = "";
                }
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  created() {},
  mounted() {},
  beforeCreate() {}
};
</script>
<style lang='scss' scoped>
.tipsBindPhone {
  width: 100%;
  height: 100%;
  .Bg {
    background: #000000;
    opacity: 0.5;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    margin: auto;
  }
  .center-form {
    padding: 0 60px;
    border-radius: 10px;
    background-color: #ffffff;
    width: 260px;
    height: 390px;
    position: absolute;
    top: 180px;
    left: 50%;
    margin-left: -190px;
    .close-icon {
      cursor: pointer;
      width: 18px;
      height: 18px;
      display: inline-block;
      background: url("../../assets/images/icons.png") no-repeat -349px -20px;
      position: absolute;
      right: 16px;
      top: 16px;
      &:hover {
        background-position: -389px -20px;
      }
    }
    .tips-title {
      margin-top: 65px;
      height: 71px;
      position: relative;
      .tips-logo {
        margin-left: 30px;
        width: 57px;
        height: 71px;
        display: inline-block;
        background: url("../../assets/images/icons.png") no-repeat -347px -81px;
      }
      .title-big {
        color: #e6892b;
        font-family: Microsoft YaHei;
        font-weight: 700;
        font-size: 22px;
        line-height: 26px;
        letter-spacing: 0px;
        text-align: center;
        position: absolute;
        left: 106px;
        top: 4px;
      }
      .title-small {
        color: #999999;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0px;
        text-align: center;
        position: absolute;
        left: 106px;
        bottom: 0;
        width: 126px;
        height: 36px;
      }
    }
    /deep/ .bindPhone-form {
      margin-top: 33px;
      .el-form-item {
        border: none !important;
        margin: 0 !important;
        .el-form-item__content {
          height: 42px !important;
          line-height: 1px !important;
        }
        .el-input {
          width: 258px;
          height: 42px !important;
          .el-input__inner {
            height: 42px !important;
            line-height: 1px !important;
          }
        }
      }
      .check-phonecode-div {
        margin-top: 18px;
        width: 150px;
        position: relative;
        .el-input {
          width: 150px !important;
          .el-input__inner {
            height: 42px !important;
            line-height: 1px !important;
          }
        }
        .el-form-item__error{
          width: 200px;
        }
        .codeError{
          font-size: 12px;
          line-height: 1;
          padding-top: 4px;
          position: absolute;
          top: 100%;
          left: 0;
          color: #f6343d;
        }
        .el-button.codeBtn {
          width: 100px;
          height: 42px;
          position: absolute;
          right: -110px;
          top: 0;
          padding: 0;
          color: #fff;
          border-radius: 6px;
          background: #4981f2;
          box-shadow: inset 0px -3px 0px 0 #3f79ee, 0px 2px 0px 0 #e5e5e5;
        }
      }
      .el-button.submitBtn {
        width: 260px;
        height: 46px;
        color: #fff;
        border-radius: 6px;
        background: #4981f2;
        word-spacing: 10px;
        box-shadow: inset 0px -3px 0px 0 #3f79ee, 0px 2px 0px 0 #e5e5e5;
        margin-left: 0;
        margin-top: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/tipsBindPhone.vue